import Vue from 'vue';
import { HTTP_GET, HTTP_POST, HTTP_PUT } from "../const";
import { LOAD_WITHDRAWS_LIST, RESET_WITHDRAWS, SWITCH_NOTE } from "../const/withdraws";

export default {
  namespaced: true,
  state: {
    withdraws: {
      list: [],
      pagination: {},
    },
    withdrawsLocales: {
      new: 'Новый',
      handler_withdraw_added: 'Вывод с обработчика запрошен',
      handler_withdraw_confirmed: 'Вывод с обработчика подтвержден',
      node_withdraw_added: 'Вывод с ноды запрошен',
      cleaner_withdraw_added: 'Превышено время ожидания вывода',
      finished: 'Завершен',
      canceled: 'Отменен',
      error: 'Ошибка',
    },
  },
  getters: {
    withdraws: state => state.withdraws,
    withdrawsLocales: state => state.withdrawsLocales,
  },
  actions: {
    [LOAD_WITHDRAWS_LIST]: async ({ dispatch, commit }, { params }) => {
      await dispatch(HTTP_GET, {
        method: LOAD_WITHDRAWS_LIST,
        namespace: 'withdraws',
        params,
      }, {root: true});
    },
    [SWITCH_NOTE]: async ({ dispatch }, { id, type }) => {
      const request = await dispatch(HTTP_PUT, {
        method: SWITCH_NOTE,
        namespace: 'orders',
        replace: { id, type },
        no_commit: true,
      }, { root: true });
      return request ? request.data : { success: false, message: 'Неудачный запрос' };
    },
  },
  mutations: {
    [LOAD_WITHDRAWS_LIST]: (state, { data }) => {
      Vue.set(state.withdraws, 'list', data.list);
      Vue.set(state.withdraws, 'pagination', data.pagination);
    },
    [RESET_WITHDRAWS]: (state) => {
      Vue.set(state, 'withdraws', {
        list: [],
        pagination: {},
      });
    },
  },
};
